import { render, staticRenderFns } from "./FooterLanding.vue?vue&type=template&id=b7146296&scoped=true"
import script from "./FooterLanding.vue?vue&type=script&lang=js"
export * from "./FooterLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7146296",
  null
  
)

export default component.exports